module.exports = __webpack_public_path__ + "static/media/foodprint.ee186f03.png";